import { css } from "@emotion/core";
import styled from "@emotion/styled";

export const SpinnerContainer = styled.div`
    ${({ height }: { height: string | number }) => css`
        width: 95%;
        height: ${height}px;
        display: flex;
        align-items: center;
        justify-content: center;
    `}
`;
